<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>App groups configuration</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div [formGroup]="parentFormGroup">
      <div class="general-settings">
        <h3>General app groups settings</h3>
        <mat-checkbox formControlName="isEmpty">Is main section empty?</mat-checkbox>
      </div>
      <div formArrayName="appGroups">
        @for (form of forms.controls; track form; let i = $index) {
          <div class="group-block">
            <div class="app-group-configuration-wrap">
              <app-group-configuration [parentFormGroup]="form"
                [appGroup]="sectionConfig.appGroups[i]"></app-group-configuration>
              <div class="controls">
                <button type="button" mat-icon-button (click)="moveAppDown(i)"
                  [disabled]="i === (sectionConfig.appGroups.length - 1)">
                  <mat-icon>arrow_downward</mat-icon>
                </button>
                <button type="button" mat-icon-button (click)="moveAppUp(i)" [disabled]="i === 0">
                  <mat-icon>arrow_upward</mat-icon>
                </button>
              </div>
            </div>
            <button type="button" mat-raised-button color="primary" (click)="deleteGroup(i)">
              <mat-icon>delete_outline</mat-icon>
              Delete Group
            </button>
          </div>
        }
      </div>
      <button type="button" mat-raised-button color="primary" (click)="addNewGroup($event)" class="add-group-button">
        <mat-icon>add</mat-icon>Add Group
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>
